/* pxxl-endless.js – 19.10.2026: sparsames Nachladen in Kategorien (ersetzt Ajaxinate).
 * - holt nur die Produktkarten (Section pxxl-endless-items, ~11 KB gzip statt 128 KB ganze Seite)
 * - IntersectionObserver mit Vorlauf, kein Scroll-Listener; erst nach echtem Scrollen
 * - AUTO Seiten automatisch, danach "Mehr laden"; ein Klick gibt wieder AUTO Seiten frei
 * - Zurück-Taste: geladene Seiten + Scrollposition aus sessionStorage wiederherstellen
 * - Schalter für spätere Tests: Cookie pxxl_endless=aus (oder ?pxxl_endless=aus) → nur Knopf, kein Auto-Nachladen;
 *   ?pxxl_endless=an löscht den Cookie. Aktive Variante steht in window.PXXL_ENDLESS und am <section data-pxxl-variante>. */
(function () {
  var AUTO = 2, VORLAUF = '1200px 0px', MINI = 'pxxl-endless-items', MINI_PER_PAGE = '40', MINI_COLUMNS = '4';
  var sec = document.querySelector('[data-section-type="collection"][data-pxxl-endless]');
  if (!sec || !('IntersectionObserver' in window) || !window.fetch) return; // dann bleibt der Theme-Knopf

  try {
    var q = new URLSearchParams(location.search).get('pxxl_endless');
    if (q === 'aus') document.cookie = 'pxxl_endless=aus; path=/; max-age=2592000; SameSite=Lax';
    if (q === 'an') document.cookie = 'pxxl_endless=; path=/; max-age=0; SameSite=Lax';
    if (q === 'aus' || (q !== 'an' && /(?:^|;\s*)pxxl_endless=aus/.test(document.cookie))) AUTO = 0;
  } catch (e) {}
  window.PXXL_ENDLESS = { variante: AUTO ? 'auto' : 'knopf', auto: AUTO };
  sec.setAttribute('data-pxxl-variante', window.PXXL_ENDLESS.variante);

  var auto = 0, laden = false, gescrollt = false, sichtbar = false, stopp = false, kaputt = false;
  var mini = sec.dataset.collectionItemsPerPage === MINI_PER_PAGE && sec.dataset.collectionColumns === MINI_COLUMNS;
  var SKEY = 'pxxl-endless:' + location.pathname + location.search;

  function partial() { return sec.querySelector('[data-partial]'); }
  function liste() { return sec.querySelector('.collection__infinite-container'); }
  function trigger() { return sec.querySelector('.collection__infinite-trigger'); }
  function link() { var t = trigger(); return t && t.querySelector('a[href]'); }
  function seite() { return parseInt(sec.getAttribute('data-pxxl-page') || '1', 10); }

  // Theme-Ajaxinate (Klickmodus) nie zum Zug kommen lassen
  function themeAus() {
    var c = window.smu_collection, i = c && c.infiniteScroll;
    if (i && !i.pxxlAus) { try { i.destroy(); } catch (e) {} i.pxxlAus = true; }
  }

  // nach dem Anhängen: Theme-Nacharbeit (Hover-Bild, Quickview, Zähler "1-80 von …")
  function themeNach() {
    var c = window.smu_collection, i = c && c.infiniteScroll;
    if (i && i.settings && typeof i.settings.callback === 'function') { try { i.settings.callback(); } catch (e) {} }
  }

  function holen(href) {
    var u = new URL(href, location.href);
    u.searchParams.delete('section_id');
    u.searchParams.set('section_id', mini ? MINI : sec.dataset.sectionId);
    return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      var d = tpl.content;
      var items = d.querySelector(mini ? '[data-pxxl-items]' : '.collection__infinite-container');
      var next = d.querySelector(mini ? '[data-pxxl-next]' : '.collection__infinite-trigger');
      if (!items) throw new Error('keine Karten');
      return { items: items, next: next, page: parseInt(u.searchParams.get('page') || '0', 10) };
    });
  }

  function anhaengen(r) {
    var l = liste(), t = trigger();
    var frag = document.createDocumentFragment();
    while (r.items.firstElementChild) frag.appendChild(r.items.firstElementChild);
    l.appendChild(frag);
    if (t) {
      t.innerHTML = r.next ? r.next.innerHTML : '';
      var a = t.querySelector('a[href]');
      if (a) { var u = new URL(a.href, location.href); u.searchParams.delete('section_id'); a.href = u.toString(); }
    }
    if (r.page) sec.setAttribute('data-pxxl-page', r.page);
    themeAus();
    themeNach();
  }

  function laden1(perKlick) {
    var a = link();
    if (!a || laden) return Promise.resolve(false);
    laden = true;
    var text = a.textContent;
    a.setAttribute('aria-busy', 'true');
    a.textContent = a.getAttribute('data-loading-text') || '…';
    return holen(a.href).then(function (r) {
      anhaengen(r);
      if (perKlick) auto = 0; else auto++;
      return true;
    }).catch(function () {
      a.textContent = text; a.removeAttribute('aria-busy');
      stopp = true; kaputt = true;
      if (perKlick === true) location.href = a.href; // Fehler beim Klick: ganz normal zur nächsten Seite
      return false;
    }).then(function (ok) {
      laden = false;
      if (ok) beobachten();
      return ok;
    });
  }

  function vielleicht() {
    if (sichtbar && gescrollt && !stopp && auto < AUTO && !laden) laden1(false);
  }

  var io = new IntersectionObserver(function (e) {
    sichtbar = e[e.length - 1].isIntersecting;
    vielleicht();
  }, { rootMargin: VORLAUF });
  function beobachten() {
    io.disconnect();
    var t = trigger();
    if (t && link()) { io.observe(t); }
  }

  window.addEventListener('scroll', function () { gescrollt = true; vielleicht(); }, { passive: true, once: true });

  // Klick auf "Mehr laden" abfangen, bevor Ajaxinate ihn bekommt
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('.collection__infinite-trigger a[href]');
    if (!a || !sec.contains(a)) return;
    if (kaputt) return; // nach Fehler: normaler Link
    ev.preventDefault(); ev.stopPropagation();
    stopp = false;
    laden1(true);
  }, true);

  // Ratgeber-Sprung (#guide) stoppt das automatische Nachladen
  var alt = window.smu_detroyinf;
  window.smu_detroyinf = function () { stopp = true; if (typeof alt === 'function') try { return alt.apply(this, arguments); } catch (e) {} };
  if (location.hash === '#guide') stopp = true;

  // Filter/Sortierung ersetzen [data-partial] → neu anfangen
  var p = partial();
  if (p) new MutationObserver(function () {
    if (laden) return;
    auto = 0; stopp = false; sichtbar = false;
    sec.setAttribute('data-pxxl-page', '1');
    SKEY = 'pxxl-endless:' + location.pathname + location.search;
    themeAus(); beobachten();
  }).observe(p, { childList: true });

  // Zurück-Taste: Stand merken und wiederherstellen
  window.addEventListener('pagehide', function () {
    try {
      if (seite() > 1) sessionStorage.setItem(SKEY, JSON.stringify({ page: seite(), y: window.scrollY, t: Date.now() }));
      else sessionStorage.removeItem(SKEY);
    } catch (e) {}
  });
  function zurueck() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;
    var s; try { s = JSON.parse(sessionStorage.getItem(SKEY) || 'null'); } catch (e) {}
    if (!s || !s.page || Date.now() - s.t > 30 * 60 * 1000) return;
    var ziel = Math.min(s.page, 12);
    (function weiter() {
      if (seite() >= ziel) { window.scrollTo(0, s.y); return; }
      laden1('zurueck').then(function (ok) { if (ok) weiter(); });
    })();
  }

  function start() {
    themeAus();
    sec.setAttribute('data-pxxl-page', new URLSearchParams(location.search).get('page') || '1');
    beobachten();
    zurueck();
  }
  // Theme-Section ist evtl. noch nicht initialisiert (smu_collection) → kurz warten
  var n = 0;
  (function warten() { if (window.smu_collection || n++ > 40) start(); else setTimeout(warten, 50); })();
})();
